const Audio = ({ audioRef = null, ...props }) => {
  return (
    <audio ref={audioRef} controls playsInline autoPlay {...props}>
      <track kind="captions" />
    </audio>
  );
};

export default Audio;
